module.exports = __webpack_public_path__ + "media/images/vector-abdb1f21b22b63dfcb8c6b7617926e72.png";